<template>
  <div id="app" class="app-root">
    <layout-header></layout-header>
    <div class="app-container" :style="{ position: modal.action && !isDialogLoading ? 'relative' : 'relative' }">
      <div class="app-pages">
        <div class="app-background" :class="{ filter: !isMainPage }" :style="{ background: '#eeeeee', backgroundSize: 'cover' }"></div>
        <div class="max-width" :style="{ minHeight: minHeight, display: isMainPage ? 'flex' : 'block', 'align-items': 'center' }">
          <div class="view-container" v-if="!isMainPage">
            <div class="view-field responsitive-color gray-transparent">
              <router-view/>
            </div>
          </div>
          <div class="main-container" v-else>
            <div class="main-field">
              <img src="./assets/images/cover.png" width="300px" />
            </div>
          </div>
        </div>
        <layout-footer></layout-footer>
      </div>
    </div>
    <div class="modal-container">
      <modal v-if="modal.action" :style="!isDialogLoading ? {} : { display: 'none' }" :width="modal.width" :height="modal.height" :customStyles="modal.customStyles" @hide="() => {
        modal.callback && modal.callback()
        setModalAction({})
      }">
        <component :is="modal.action" :param="modal.param" @changeModal="(option, param) => {
          modal.callback && modal.callback(param)
          this.setModalAction(option || {})
        }"></component>
      </modal>
    </div>
    <layout-toast></layout-toast>
    <layoutLoading v-if="isLoading"></layoutLoading>
    <layoutUploading v-if="isUploading"></layoutUploading>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { getUserToken } from './api'
import layoutHeader from './components/layout/header'
import layoutFooter from './components/layout/footer'
import layoutToast from './components/tool/toast'
import layoutLoading from './components/layout/loading'
import layoutUploading from './components/layout/uploading'
import responsitive from './mixins/responsitive'
import toastMethods from './mixins/toastMethods'
import loginData from './mixins/loginData'
// modals
import modal from './components/dialog/container'
import login from './components/dialog/login'
import sticker from './components/dialog/sticker'
import shipment from './components/dialog/shipment'
import electropherogramImage from './components/dialog/electropherogramImage'
import sample from './components/dialog/sample'
import runlistMap from './components/dialog/runlistMap'
import upload from './components/dialog/upload'
import toast from './components/dialog/toast'

require('font-awesome-sass-loader')

export default {
  name: 'app',
  components: {
    layoutHeader,
    layoutFooter,
    layoutToast,
    layoutLoading,
    layoutUploading,
    // modals
    modal,
    login,
    sticker,
    shipment,
    electropherogramImage,
    sample,
    runlistMap,
    upload,
    toast
  },
  mixins: [
    responsitive,
    loginData,
    toastMethods
  ],
  data () {
    return {
      minHeight: '300px'
    }
  },
  watch: {
    '$route' () {
      const { body } = document
      body.scroll(0, 0)
    },
    async 'isLogin' (n, o) {
      if (o !== null) {
        this.setLoadingAction(true)
        await this.preFetchDataGuest()
        if (n) {
          await this.preFetchData()
        }
        this.appInitialAction(n)
        this.setLoadingAction(false)
      }
    }
  },
  computed: {
    ...mapGetters([
      'normalPage',
      'userPage',
      'adminPage',
      'staffPage',
      'labPage',
      'isLogin',
      'isLoading',
      'isDialogLoading',
      'isUploading',
      'modal'
    ]),
    isMainPage () {
      return ['main', ''].includes(this.$route.path.split('/')[1])
    }
  },
  created () {
    this.setModalAction({})
    this.setLoadingAction(true)
    setTimeout(() => this.validateLogin())
  },
  beforeMount () {
    const { body } = document
    const handler = () => {
      if (!document.hidden) {
        let rect = body.getBoundingClientRect()
        let headerHeight = 60
        let footerHeight = 0
        let height = rect.height - headerHeight - footerHeight + 1
        this.minHeight = height + 'px'
      }
    }
    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
  },
  methods: {
    ...mapActions([
      'appInitialAction',
      'setLoadingAction',
      'setDialogLoadingAction',
      'clearLoadingAction',
      'clearDialogLoadingAction',
      'setModalAction'
      // global
    ]),
    async preFetchDataGuest () {
    },
    async preFetchData () {
    },
    async validateLogin () {
      let userInfo = this.$ls.get('userInfo') || {}
      await this.preFetchDataGuest()
      if (userInfo['access-token']) {
        await this.preFetchData()
        await this.getUserByToken(userInfo)
      } else {
        this.setUserData(null)
        this.appInitialAction(false)
        this.validateRoute(false)
      }
    },
    async getUserByToken (data) {
      try {
        let response = await getUserToken(data)
        let user = response.data.data
        this.setUserData(response)
        this.appInitialAction(true)
        this.validateRoute(true, user.role, false)
      } catch (error) {
        this.setUserData(null)
        this.appInitialAction(true)
        this.addToast('error', !error.response ? error.message : error.response.data.errors[0])
        this.validateRoute(false)
      }
    },
    validateRoute (isLogin, role, admin) {
      let array = []
      if (isLogin) {
        switch (role) {
          case 'admin': {
            array = _.union(this.adminPage, this.normalPage)
            break
          }
          case 'staff': {
            array = _.union(this.staffPage, this.normalPage)
            break
          }
          case 'lab': {
            array = _.union(this.labPage, this.normalPage)
            break
          }
          default: {
            array = _.union(this.userPage, this.normalPage)
          }
        }
      } else {
        array = this.normalPage
      }
      if (admin) {
        array = _.union(array, this.adminPage)
      }
      this.validateRole(isLogin, array)
    },
    validateRole (isLogin, pages) {
      let routeName = this.$route.name
      if (routeName && !_.includes(pages, routeName)) {
        this.addToast('error', isLogin ? '權限不足' : '請先登入')
        this.$router.push({name: 'main'})
        this.setLoadingAction(false)
      } else {
        this.setLoadingAction(false)
      }
    }
  }
}
</script>

<style lang="sass">
@import sass/style
</style>



// WEBPACK FOOTER //
// src/App.vue